module.exports = __webpack_public_path__ + "static/img/banner03.b76a793a.jpg";